import React, {Component} from 'react';
import {orgId} from '../../context/context';

export default class NoForm extends Component {

  render() {
    return <div className="row justify-content-center">
      <div className="col-12 col-md-10 alert alert-danger text-center"
           style={{paddingTop: '10px', paddingBottom: '10px'}}>
        Please create at least <a href={`/forms?shop=${orgId}`}>one form</a>
      </div>
    </div>
  }

}
